// extracted by mini-css-extract-plugin
export default {"Container":"PostWithComments_Container__HGZhr","ContainerWithImg":"PostWithComments_ContainerWithImg__-DAVe","ContainerWithoutImg":"PostWithComments_ContainerWithoutImg__5+mhA"};